import { Component, EventEmitter, h, Prop, Event } from "@stencil/core";
import { StringUtils } from "../../core/utils/StringUtils";

@Component({
    tag: "snt-faq-filter-slider",
    styleUrl: "faq-filter-slider-component.scss",
    shadow: false
})
export class FAQFilterSliderComponent {

    public static readonly TAG_NAME = "snt-faq-filter-slider";

    private _filterArr: any[];

    @Prop({ reflect: true }) filterItems: string;
    @Prop() menuAriaLabel: string;
    @Event({ bubbles: true }) faqFilterClick: EventEmitter<string>;
    @Prop({ reflect: true }) currentActive: string;

    onFilterClick(filterKey: string) {
        if (this.currentActive !== filterKey) {
            this.currentActive = filterKey;
            this.faqFilterClick.emit(filterKey);
        }
    }

    componentWillRender() {
        try {
            this._filterArr = JSON.parse(this.filterItems);
        } catch (e) {
            console.log(`Error parsing filterItems: ${this.filterItems}`)
        }
        if (StringUtils.isEmpty(this.currentActive)) {
            this.currentActive = this._filterArr.length != 0 ? this._filterArr[0].key : "";
        }
    }

    render() {
        return [
            <host class={this._filterArr.length === 0 ? "hide" : ""}>
                <div class="spacings">
                    <div class="wrapper">
                        <div class="right-gradient"></div>
                        <div class="left-gradient"></div>
                        <div class="filter-container">
                            <nav aria-label={this.menuAriaLabel}>
                                <ul>
                                    {
                                        this._filterArr.map(item => (
                                            <li>
                                                <a href="javascript:void(0)" class={item.key == this.currentActive ? "active" : ""} onClick={this.onFilterClick.bind(this, item.key)}>{item.title}</a>
                                                <span class="bold-hidden">{item.title}</span>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </host>
        ];
    }
}
